import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  Paper,
  Box,
} from '@mui/material';
import BaseModal from '../../../../components/modals/BaseModal';
import FallIcon from '../../../../resources/images/chat_icons/FallIcon.svg';
import SOSIcon from '../../../../resources/images/chat_icons/SOSIcon.svg';
import ArcFlashIcon from '../../../../resources/images/chat_icons/ArcFlashIcon.svg';
import ImpactIcon from '../../../../resources/images/chat_icons/ImpactIcon.svg';
import { convertTimestampToUTCDate } from '../../../../utils/date_convert';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../../../resources/strings/StringKeys';
import useMapToUser from '@/hooks/useMapToUser';

function EmergencyListModal({
  onHide,
  show,
  emergencies,
  setSelectedEmergency,
  setShowEmergencyChat,
}) {
  const { t } = useTranslation();

  const { moveMapToUser } = useMapToUser();

  const getIncidentIcon = (incidentType) => {
    switch (incidentType) {
      case 'Arc Flash':
        return (
          <img src={ArcFlashIcon} height={50} width={50} alt="Arc Flash" />
        );
      case 'Head Impact':
        return (
          <img src={ImpactIcon} height={50} width={50} alt="Head Impact" />
        );
      case 'Dangerous Fall':
        return (
          <img src={FallIcon} height={50} width={50} alt="Dangerous Fall" />
        );
      case 'SOS Button':
        return <img src={SOSIcon} height={50} width={50} alt="SOS Button" />;
      default:
        return null;
    }
  };

  return (
    <BaseModal
      open={show}
      submitButtonText={t(StringKeys.CLOSE)}
      onClose={onHide}
      onSubmit={onHide}
      title={t(StringKeys.ACTIVE_EMERGENCIES)}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      {/* Modal Content */}
      <Box>
        <TableContainer sx={{ boxShadow: 0 }} component={Paper}>
          <Table aria-label="emergency table">
            <TableBody>
              {emergencies && Object.keys(emergencies).length > 0 ? (
                Object.values(emergencies).map((emergencyGroup, index) => {
                  const emergency = emergencyGroup.emergency;
                  if (emergency.isActiveEmergency()) {
                    return (
                      <TableRow
                        onClick={() => {
                          setSelectedEmergency(emergencyGroup);
                          setShowEmergencyChat(true);
                          // navigate to the pin on the map
                          moveMapToUser(emergency.creator_auth_id);
                          onHide();
                        }}
                        style={{ cursor: 'pointer' }}
                        key={index}
                      >
                        <TableCell>
                          {getIncidentIcon(emergency.incident)}
                        </TableCell>
                        <TableCell>{emergency.incident}</TableCell>
                        <TableCell>
                          {emergency.creator_first_name}{' '}
                          {emergency.creator_last_name}
                        </TableCell>
                        <TableCell>
                          {convertTimestampToUTCDate(
                            emergency.creation_timestamp,
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  }
                  return null;
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={4}>
                    {t(StringKeys.THERE_ARE_NO_CURRENT_ACTIVE_EMERGENCIES)}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </BaseModal>
  );
}

export default EmergencyListModal;
